module.exports = __webpack_public_path__ + "media/OS.031ae3f7.wav";